import type { NormalizedCacheObject } from '@apollo/client'
import { ApolloClient, ApolloLink } from '@apollo/client'
import type { ErrorResponse } from '@apollo/client/link/error'
import { onError } from '@apollo/client/link/error'
import { SchemaLink } from '@apollo/client/link/schema'

import { schema } from '@acre/graphql/schema'
import { authRedirectErrorLink, graphqlErrorLink, lutherErrorLink } from '@acre/utils'

import cache from './cache'

const initApollo = () => {
  const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
    connectToDevTools: process.env.NODE_ENV !== 'test',
    link: ApolloLink.from([
      onError(graphqlErrorLink),
      onError(lutherErrorLink),
      onError((error: ErrorResponse) => authRedirectErrorLink(error, client)),
      new SchemaLink({
        schema,
        context: (operation) => operation.getContext(),
      }),
    ]),
    cache,
  })

  return client
}

export default initApollo

export const client = initApollo()
